import { fetchApi } from '@/config/axiosSetting';

import {
  BodyDriverInfoType,
  BodyDriverInfoTypeParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationDriverInfo/getInsurerInformationDriverInfoQuery.type';

export const getInsurerInformationDriverInfoQueryFunction = (
  params: BodyDriverInfoTypeParams,
): Promise<BodyDriverInfoType> => {
  return fetchApi.get(
    `/body/reports/${params?.id}/insurer_information/driver/`,
  );
};
